import { Box, IconButton, Typography } from '@mui/material';
import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import MenuIcon from '@mui/icons-material/Menu';
import MobileDrawer from './Mobile';
import LocalMallRoundedIcon from '@mui/icons-material/LocalMallRounded';
import { typeMappingHandler } from '../../../constants/keysMapping';
import { useSelector } from 'react-redux';
import { cartSelector } from '../../../store/user/user.selector';
import { privateRoutes } from '../../../configs/routes';
import Badge from '@mui/material/Badge';
import { makeStyles } from '@mui/styles';
import './appbar.scss';

const useStyles = makeStyles(() => ({
  customBadge: {
    color: 'white',
  },
}));
const AppBar = () => {
  const { pathname } = useLocation();
  const styles = useStyles();
  const navigate = useNavigate();
  const cart = useSelector(cartSelector);
  const [openMenu, setOpenMenu] = useState(false);

  return (
    <Box className='appbar'>
      <Box className='mainAppbar'>
        <Box className='titleContainer'>
          <IconButton disableRipple className='menuIcon' onClick={() => setOpenMenu(true)}>
            <MenuIcon color='action' />
          </IconButton>

          <Box className='spaceBetween'>
            <Typography className='title' color='text.main'>
              {typeMappingHandler(pathname).message}
            </Typography>

            <IconButton onClick={() => navigate(privateRoutes.cart)}>
              <Badge
                badgeContent={cart?.length}
                color='secondary'
                classes={{ badge: styles.customBadge }}
              >
                <LocalMallRoundedIcon color='primary' />
              </Badge>
            </IconButton>
          </Box>
        </Box>
      </Box>

      <MobileDrawer openMenu={openMenu} setOpenMenu={() => setOpenMenu(false)} />
    </Box>
  );
};

export default AppBar;
